<template>
  <PopupContent>
    <PopupTitle>Фінанси</PopupTitle>
    <InfoRow v-if="showActButton" class="mb-2">
      <BlueButton
        class="withdrawal-request"
        @click="handleWithdrawalRequest"
      >
        Подати запит на виведення коштів
      </BlueButton>
    </InfoRow>
    <InfoRow class="mb-2">
      <h4>Ваш баланс</h4>
      <p class="balance-value">{{ hideBalance ? '_' : formatBalance(balance) }} <BalanceHryvnaIcon class="ml-2" /></p>
    </InfoRow>
    <InfoRow class="mb-2">
      <h4>Кредитний ліміт</h4>
      <p class="balance-value">{{ hideBalance ? '_' : formatBalance(creditLimit) }} <CreditLimitIcon class="ml-2" /></p>
    </InfoRow>
    <Divider type="horizontal" />
    <InfoRow>
      <ActionButton
        v-if="!hideBalance"
        @click="$emit('toggle-balance-visibility', false)"
      >
        <HideBalanceIcon class="mr-2" />
        Сховати баланс
      </ActionButton>
      <ActionButton
        v-else
        @click="$emit('toggle-balance-visibility', false)"
      >
        <ShowBalanceIcon class="mr-2" />
        Показати баланс
      </ActionButton>
    </InfoRow>
    <InfoRow>
      <ActionLink :route="{ name: 'score' }"><OrderHistoryIcon class="mr-2" />Історія транзакцій</ActionLink>
    </InfoRow>
    <InfoRow v-if="getCurrentUserId === 1">
      <CreateInvoice class="mr-2"></CreateInvoice>
    </InfoRow>
  </PopupContent>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateInvoice from '@/components/app/invoice/CreateInvoice.vue';
import { withdrawalRequest } from '@/features/account-balance/lib';
import { WITHDRAWAL_MONEY_REQUEST_POPUP_EVENTS } from '@/features/withdrawal-money-request';
import { balanceFormatter } from '@/shared/lib/balance';
import { Divider } from '@/shared/ui/divider';
import { BlueButton } from '@/shared/ui/form';
import { BalanceHryvnaIcon, CreditLimitIcon, HideBalanceIcon, OrderHistoryIcon, ShowBalanceIcon } from '@/shared/ui/icons';
import { ActionButton, ActionLink, InfoRow, PopupContent, PopupTitle } from '@/shared/ui/popup';

export default {
  props: {
    balance: {
      type: Number,
      default: 0,
      required: false,
    },
    creditLimit: {
      type: Number,
      default: 0,
      required: false,
    },
    hideBalance: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CreateInvoice, BalanceHryvnaIcon, CreditLimitIcon, ShowBalanceIcon, HideBalanceIcon, OrderHistoryIcon, Divider,
    PopupContent, PopupTitle, ActionLink, ActionButton, InfoRow, BlueButton
  },
  mixins: [ balanceFormatter, withdrawalRequest ],
  computed: {
    ...mapGetters('currentUserModule', ['getCurrentUserId']),
    showActButton() {
      return this.shouldShowActButton();
    },
  },
  methods: {
    handleWithdrawalRequest() {
      this.$eventBus.$emit('mobile-menu-close');
      this.$eventBus.$emit(WITHDRAWAL_MONEY_REQUEST_POPUP_EVENTS.OPEN);
    },
  },
};
</script>

<style lang="scss" scoped>
p {
    margin: 0;
}

.balance-value {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.withdrawal-request {
  font-size: 14px !important;
  padding: 12px !important;
  margin-bottom: 10px;
  width: 100%;
}
</style>
